import { LCIResult } from 'hooks/data/datasets/lci/types';

export const buildCompartmentKey = (e: LCIResult) => `${e.compartment} ${e.sub_compartment}`;

export const isValidCompartment = (item: LCIResult, compartments: string[]) => {
  return !compartments.length ? true : compartments.indexOf(buildCompartmentKey(item)) !== -1;
};
